import React,{ useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import { Dialog } from "primereact/dialog";
import { Sidebar } from "primereact/sidebar";

import Menu from "../../helpers/Menu";
import Table  from "../../helpers/Table";
import Button from "../../helpers/Button";

import Loading from "../../common/Loading";
import PMCompanyName from "../../common/PMCompanyName";
import PMUserName from "../../common/PMUserName";
import Description from "../../common/Description";
import ButtonGroup from "../../common/ButtonGroup";
import CopyToClipboard from "../../common/CopyToClipboard";

import Search from "./Components/Search";
import ChequeModal from "./Components/chequeModal";
import { CalendarField, CheckboxField, TextAreaField } from "../../helpers";

import { cancelVendorPaymentsStatus, updateVendorPaymentsStatus, updateVendorPaymentsStatusAndCheque } from "../../services/api/vendorPayment";
import { fetchVendorPaymentsCheque, updateVendorPaymentChequeData, setIsSearchVisible, setIsSearchPinned } from "../../services/redux/reducers/vendorPaymentCheque/vendorPaymentCheque";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchChequeBooks, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { updateRealisedDate } from "../../services/api/cheques";
import { round, numberConversion, getDateString, isMobile } from "../../utils";

import "./index.css"

import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../../constants";

const VendorPaymentCheque = () => {
    const [isCancelVisible, setIsCancelVisible] = useState(false)
    const [isPIVisible, setIsPIVisible] = useState(false)
    const [isBankDetailsVisible, setIsBankDetailsVisible] = useState(false)

    const [displayedBankDetails, setDisplayedBankDetails] = useState([])
    const [sellerPIPunch, setSellerPIPunch] = useState([])
    const [selectedVendorPayments, setSelectedVendorPayments] = useState([])
    const [selectedVendorPaymentsAmount, setSelectedVendorPaymentsAmount] = useState(null)
    const [cancelReason, setCancelReason] = useState()
    const [isChequeModalVisible, setIsChequeModalVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isHoveringSearchZone, setIsHoveringSearchZone] = useState(false)
    const [hasEverHoveredRightEdge, setHasEverHoveredRightEdge] = useState(false)

    const isTableLoading = useSelector(state => state.vendorPaymentsCheque.loading)

    const usersData = useSelector(state => state.userDetails)
    const searchParams = useSelector(state => state.vendorPaymentsCheque.searchParams)
    const paginationParams = useSelector(state => state.vendorPaymentsCheque.paginationParams)
    const vendorPaymentsData = useSelector(state => state.vendorPaymentsCheque.vendorPaymentsChequesData)
    const sellerPIPunches = useSelector(state => state.vendorPaymentsCheque.sellerPIPunches)
    const sellerPOApprovals = useSelector(state => state.vendorPaymentsNonCredit.sellerPOApprovals)
    const companyBankAccounts = useSelector(state => state.vendorPaymentsCheque.companyBankAccounts)
    const isSearchVisible = useSelector(state => state.vendorPaymentsCheque.isSearchVisible)
    const isSearchActive = useSelector(state => state.vendorPaymentsCheque.isSearchActive)
    const isSearchPinned = useSelector(state => state.vendorPaymentsCheque.isSearchPinned)

    const statusList = useSelector((state) => state.common.status)
    const chequeBooksData = useSelector(state => state.common.chequeBooks)
    const pmCompanyBankDetails = usersData?.PMCompanyDetails?.companyBankAccounts

    const usersList = usersData?.PMCompanyDetails?.companyUsers

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig
    
    const actionMenu = useRef(null)
    const dispatch = useDispatch()

    const isMobileDevice = isMobile()
    
    useEffect(() => {
        dispatch(fetchStatus())
        dispatch(fetchChequeBooks())
    }, [vendorPaymentsData])

    useEffect(() => {
        let totalAmount = 0
        selectedVendorPayments?.map(eachVendorPayment => {
            totalAmount += eachVendorPayment?.amount
        })
        totalAmount = round(totalAmount)
        setSelectedVendorPaymentsAmount(totalAmount)
    }, [selectedVendorPayments])

    useEffect(() => {
        if (!isSearchPinned && !isHoveringSearchZone) {
            dispatch(setIsSearchVisible(false))
          }

        const handleMouseMove = (e) => {
            if (isSearchPinned) return

            const panelWidth = window.innerWidth * 0.18
            const buffer = 8
            const screenRightEdge = window.innerWidth
            const activeZoneLeft = screenRightEdge - (panelWidth + buffer)

            if (e.clientX < activeZoneLeft) {
                setIsHoveringSearchZone(false)
                setHasEverHoveredRightEdge(false)
            } else {
                setIsHoveringSearchZone(true)
            }
        }

        if (!isSearchPinned && (isHoveringSearchZone || hasEverHoveredRightEdge)) {
            window.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove)
        }
    }, [isSearchPinned, isHoveringSearchZone, hasEverHoveredRightEdge])

    const getHeaderCheckbox = () => {
        const relatedSelectedVendorPayments = vendorPaymentsData.filter(eachVendorPayment => {
            const selectedVendorPaymentExists = selectedVendorPayments.some(obj => obj.vendorPaymentId === eachVendorPayment.vendorPaymentId)
            return selectedVendorPaymentExists
        })
        return(
            <div className=""> 
                <CheckboxField onChange={(e) => handleSelectClick(e)} checked={vendorPaymentsData?.length > 0 && vendorPaymentsData?.length === relatedSelectedVendorPayments?.length}/>
            </div>
        )
    }

    const getBodyCheckbox = (row)=>{
        const relatedVendorPayment = selectedVendorPayments?.find(eachVendorPayment => eachVendorPayment?.vendorPaymentId === row?.vendorPaymentId)
        return(
            <CheckboxField onChange={() => handleCheckboxClick(row)} checked={relatedVendorPayment ? true : false}/>
        )
    }

    const getPaymentNo = (row)=>{
        const date = moment(row?.createdAt).format(DATE_TIME_FORMAT)
        return(
            <div className='req-no-container' style={{position: "relative"}}>
            <div className='flex flex-row justify-content-center align-items-center'>
                {
                    row?.docNo ? 
                    <>
                        <p className='doc-no' style={{cursor: "pointer"}} >{row?.docNo}</p>
                        <CopyToClipboard text={row?.docNo} />
                    </>
                    : ""
                } 
            </div>
            <p className='m-0 date'>{date}</p>
        </div>
        )
    }

    const getIncludeBody = (row)=>{
        return(
            <div className="text-center">
                {row?.isIncludedInBudget ? "Yes" : "No"}
            </div> 
        )
    }

    const getDocNo = (row)=>{
        const date = moment(row?.["sellerPO.createdAt"]).format(DATE_TIME_FORMAT)
        return(
            <div className='req-no-container' style={{position: "relative"}}>
            <div className='flex flex-row justify-content-center align-items-center'>
                {
                    row?.["sellerPO.docNo"] ? 
                    <>
                        <CopyToClipboard text={row?.["sellerPO.docNo"]} />
                        <p className='doc-no' style={{cursor: "pointer"}} onClick={() => window.open(`/sellerpo/${row?.sellerPOId}`)} >{row?.["sellerPO.docNo"]}</p>
                        {row["sellerPO.mongoSellerPOId"] ? <i className="pi pi-external-link pl-1 doc-copy-icon" onClick={() => window.open(`https://app.procmart.com/admin/sellerpo/${row["sellerPO.mongoSellerPOId"]}`, "_blank")} ></i> : null}
                    </>
                    : ""
                } 
            </div>
            {/* <p className='mr-4 date'>{row["sellerPO.companies.companyName"]}</p> */}
            <p className='date'>{date}</p>
        </div>
        )
    }

    const getStatusBody = (row)=>{
        const relatedStatus = statusList?.find(eachStatus => eachStatus.statusId === row?.statusId)

        if(relatedStatus?.statusId === 10){ // PAYMENT DONE
            return(
                <div className="text-center" style={{fontSize: "12px", color: "green"}} >
                    <div>{relatedStatus?.status}</div>
                </div> 
            )
        }
        if(relatedStatus?.statusId === 11){ // PAYMENT REJECTED
            return(
                <div className="text-center" style={{fontSize: "12px", color: "red"}} >
                    <div>{relatedStatus?.status}</div>
                </div> 
            )
        }
        if(relatedStatus?.statusId === 6){ // CANCELLED
            return(
                <div className="text-center" style={{fontSize: "12px", color: "red"}} >
                    <div>{relatedStatus?.status}</div>
                </div> 
            )
        }
        return(
            <div className="text-center" style={{fontSize: "12px"}} >
                <div>{relatedStatus?.status}</div>
            </div> 
        )
    }

    const getKAMBody = (row)=>{
        // return(
        //     <div className="text-center">
        //         <div>{row["users.firstName"]+" "+row["users.lastName"]}</div>
        //     </div> 
        // )
        let kamName = row["users.firstName"] 

        if(row["users.lastName"]){
            kamName = kamName + " " + row["users.lastName"]
        }
        return <PMUserName userName={kamName} userId={row.createdBy}/>
    }

    const getPaymentModeBody = (row)=>{
        let relatedChequeBook
        relatedChequeBook = chequeBooksData?.find(eachChequeBook => {
            return eachChequeBook?.chequeBookId === row["cheques.chequeBookId"]
        })
        const relatedBank = pmCompanyBankDetails?.find(eachBankDetail => eachBankDetail?.bankAccId === relatedChequeBook?.bankAccId)

        return(
            row?.chequeId ? 
                (
                    <div className="text-center">
                        <b style={{textAlign: "center"}}>{row["cheques.chequeNo"]}</b>
                        <p className="m-0 p-0" style={{fontSize: "12px", minWidth: "160px", wordBreak:"break-all"}}>A/C No: {relatedBank?.accNo}</p>
                    </div> 
                ) : 
                (
                    <div className="text-center" style={{fontSize: "12px"}}>
                        <div>{row?.paymentMode}</div>
                    </div> 
                )
        )
    }

    const handleRealisedChange = async (e, row) => {
        e.preventDefault()
        if (window.confirm("Do You want to assign the realised Date?")){
            let data = {
                vendorPaymentId: row.vendorPaymentId,
                chequeId: row.chequeId,
                chequeRealisedDate: e.target.value
            }
            
            const response = await updateRealisedDate(data)
            if (response.failure){
                dispatch(raiseToast({severity:'error', detail: response?.data?.error, life: 3000}))
            }else {
                const reduxUpdateObj = {
                    statusId: 10,
                    chequeRealisedDate: e.target.value,
                    "cheques.chequeRealisedDate": e.target.value
                }

                handleUpdateVendorPayments([row.vendorPaymentId], reduxUpdateObj)
                dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Cheque Realised", life: 3000}))
            }
        }
    }

    const handleSearchTabDisplay = () => {
        if (!isSearchPinned) {
          dispatch(setIsSearchVisible(!isSearchVisible))
        }
    }

    const getRealisedDateBody = (row)=>{
        return(
            row.chequeId ? 
            (
                row["cheques.chequeRealisedDate"] ? (<div>{moment(row["cheques.chequeRealisedDate"]).format(DATE_FORMAT)}</div>) : (<div><CalendarField value={undefined} onChange={e => handleRealisedChange(e, row)}/></div>)
            ) : (
                <div>-</div>
            )
        )
    }

    const getPurchaseInvBody = (row)=>{
        const relatedSellerPIPunches = sellerPIPunches?.filter(eachSellerPIPunch => eachSellerPIPunch?.sellerPOId === row?.sellerPOId)
        return(
            <div>
                {
                    relatedSellerPIPunches?.length > 0 ?
                    (
                        <Button label="PI" className="small-btn" onClick={() => handlePIView(row)}/>
                    ): "-"
                }
            </div>
        )
    }

    const getBankDetailsBody = (row)=>{
        const relatedBankDetails = companyBankAccounts?.filter(eachBankDetails => eachBankDetails.branchId?.includes(row.branchId))
        return(
            <div>
                {
                    relatedBankDetails?.length > 0 ?
                    (
                        <a style={{cursor: "pointer", textDecoration: "underline"}} onClick={() => handleBankDetailsView(row)} > View </a>
                    ): "-"
                }
            </div>
        )
    }

    const getCompanyBody = (row)=>{
        let companyName = row["sellerPO.companies.companyName"]
        let companyId = row["sellerPO.companyId"]

        return<PMCompanyName companyName={companyName} companyId={companyId}/>
    }

    const getRemarksBody = (row)=>{
        let remarks = ""
        if(row.processedRemarks){
            remarks = row.processedRemarks
        }

        return(
            remarks ? <Description text={remarks} maxLength={100} /> : <p className="text-center">-</p>
        )
    }

    const getNoteBody = (row)=>{
        let remarks = ""
        if(row.remarks && row.remarks != "undefined"){
            remarks = row.remarks
        }

        return(
            <div className="text-left">
                {/* <div>{remarks}</div> */}
               { remarks ? <Description text={remarks} maxLength={100} /> : <p className="text-center">-</p>}
            </div> 
        )
    }

    const getApprovedByBody = (row)=>{
        let approvedByUserName = ""
        if(row["approvedVendorUsers.firstName"]){
            approvedByUserName += row["approvedVendorUsers.firstName"]
        }
        if(row["approvedVendorUsers.lastName"]){
            approvedByUserName += " " + row["approvedVendorUsers.lastName"]
        }

        let relatedSellerPOAmountApprover = sellerPOApprovals.find(eachSellerPOApproval => eachSellerPOApproval["sellerPODocNo"] === row["sellerPO.docNo"])

        if(relatedSellerPOAmountApprover && row["approvedOrRejectedBy"] === 18766){
            approvedByUserName = relatedSellerPOAmountApprover.processedByName
        }
        
        return (
            <div className="text-center">
                {
                    row.approvedOrRejectedBy ?
                    (
                        <div className="text-center">
                            <div>{approvedByUserName}</div>
                        </div> 
                    ): "-"
                }
            </div>    
        )
    }

    const getBookingStatus = (row) => {
        if(row?.sellerPIPunchId){
            const relatedSellerPIPunch = sellerPIPunches?.find(eachSellerPIPunch => eachSellerPIPunch?.sellerPIPunchId === row?.sellerPIPunchId)

            const bookedUserId = relatedSellerPIPunch.bookedBy ? relatedSellerPIPunch.bookedBy : relatedSellerPIPunch.unbookedBy
            let bookedByUser = null 
            let bookedByUserName = ""

            if(bookedUserId){
                bookedByUser = usersList.find(user => user.userId == bookedUserId)
                if(bookedByUser){
                    bookedByUserName += bookedByUser.firstName 
                    if(bookedByUser.lastName){
                        bookedByUserName += " " + bookedByUser.lastName
                    }
                }
            }
            return (
                <div className="text-center">
                    <div style={{fontSize: "12px"}}>{ (relatedSellerPIPunch?.bookedStatus ? 'BOOKED' : 'NOT BOOKED') }</div>
                    <div style={{fontSize: "12px"}}>{relatedSellerPIPunch?.bookedAt ? moment(relatedSellerPIPunch['bookedAt']).format(DATE_FORMAT) : null}</div>
                    <div style={{fontSize: "12px"}}>{bookedByUserName}</div>
                </div>
            )
        } else {
            return "-"
        }
    }

    const getAmount = (row) =>{
        return numberConversion(row.amount, numberLocale)
    }

    const getPaymentDate = (row) =>{
        return moment(row.paymentDate).format(DATE_FORMAT)
    }

    const getChequeDate = (row) =>{
        return row?.chequeDate ? moment(row?.chequeDate).format(DATE_FORMAT) : "-"
    }

    const getGSTINStatus = (row) => {
        let statusColor = "green-text"
        if(row["sellerGSTIN.statusId"] != 1){
            statusColor = "red-text"
        }
        if([21, 22].includes(row["sellerGSTIN.statusId"])){
            statusColor = "orange-text"
        }

        if(row["sellerGSTIN.statusId"]){
            const relatedStatus = statusList.find(eachStatus => eachStatus.statusId === row["sellerGSTIN.statusId"])
            return (
                <>
                    <p className="m-0 doc-no">{row["sellerGSTIN.gstinCode"]}</p>
                    <p className={`m-0 ${statusColor}`}>{relatedStatus.status}</p>
                </>
            )
        } else {
            return (
                <>
                    <p className="m-0">{row["sellerGSTIN.gstinCode"]}</p>
                    <p className="m-0 green-text">ACTIVE</p>
                </>
            )
        }
    }

    const tableColumns = [
        {
            header: getHeaderCheckbox, body: (row) => getBodyCheckbox(row)
        },
        {
            header: 'Payment No.', field: 'paymentNo', body:getPaymentNo, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Document No', field: '', body: getDocNo, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Company', field: '', body: getCompanyBody, style:{ textAlign: "center", minWidth: "200px" }
        },
        {
            header: 'GSTIN / Status', field: '', body: getGSTINStatus, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'KAM', field: '', body : getKAMBody, style:{ textAlign: "center", minWidth: "150px" }
        },
        {
            header : 'Payment Date', field : 'paymentDate', body: getPaymentDate, style:{ textAlign: "center", minWidth: "100px" }
        },
        {
            header: 'Amount', field: 'amount', body : getAmount, style:{ textAlign: "center" }
        },
        {
            header: 'TDS', field: 'tdsAmount', style:{ textAlign: "center", minWidth: "80px" }
        },
        /*{
            header: 'TCS', field: 'tcs', style:{ textAlign: "center" }
        },*/
        {
            header: 'Mode', field: '', body : (row) => getPaymentModeBody(row), style:{ minWidth: "70px" }
        },
        {
            header: 'Cheque Date', field: 'chequeDate', body: getChequeDate, style:{ textAlign: "center", minWidth: "100px" }
        },
        {
            header: 'Realised Date', field: '', body: getRealisedDateBody, style:{ textAlign: "center", minWidth: "100px" }
        },
        /*{
            header: 'Included In Budget', field: getIncludeBody, style:{ textAlign: "center", minWidth: "120px" }
        },*/
        {
            header: 'Status', field: '', body: getStatusBody, style:{ textAlign: "center" }
        },
        {
            header: 'Approved By', field: '', body: getApprovedByBody, style:{ textAlign: "center", minWidth: "150px" }
        },
        {
            header: 'Purchase Inv', field: 'purchaseInv' , body: getPurchaseInvBody, style:{ textAlign: "center", minWidth: "100px" }
        },
        {
            header: 'Bank Details', field: '', body: getBankDetailsBody, style:{ textAlign: "center" }
        },
        {
            header: 'Booking Status', field: '', body: getBookingStatus, style:{ textAlign: "center" , minWidth: "180px" }
        },
        {
            header: 'Note', field: '', body: getNoteBody, style:{ textAlign: "left",  minWidth: "250px" }
        },
        {
            header: 'Remarks', field: '', body: getRemarksBody, style:{ textAlign: "center", minWidth: "250px" }
        },
        // {
        //     header: 'Cancel', field: '', style:{ textAlign: "center" }
        // },
        {
            header: 'Cancel Reason', field: 'cancelReason', style:{ textAlign: "center",  minWidth: "130px" }
        },
    ]

    const actionMenuItems = [
        {
            label: 'Process Payments',
            icon: '',
            command : () => handleApprovePayments(),
            permissions: [145]
        },
        {
            label: 'Reject Payments',
            icon: '',
            command : () => handlePaymentRejectClick(),
            permissions: [144]
        },
        {
            label: 'Cancel Payments',
            icon: '',
            command : () => handlePaymentCancelClick(),
            className: "cancel-btn",
            permissions: [142]
        },
    ]

    const handlePIView = (row) => {
        const relatedSellerPIPunches = sellerPIPunches?.filter(eachSellerPIPunch => eachSellerPIPunch?.sellerPOId === row?.sellerPOId)
        setIsPIVisible(true)
        setSellerPIPunch(relatedSellerPIPunches)
    }

    const handleBankDetailsView = (row) => {
        const relatedBankAccounts = companyBankAccounts?.filter(eachBankDetails => eachBankDetails.branchId?.includes(row.branchId))
        setIsBankDetailsVisible(true)
        setDisplayedBankDetails(relatedBankAccounts)
    }

    const resetSelectedVendorPayments = () => {
        setSelectedVendorPayments([])
    }

    const handlePageChange = async (e) => {
        let vendorPaymentParams = { 
            ...searchParams,
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            paymentMode: ["CHEQUE"]
        }
        if(!searchParams.statusId){
            vendorPaymentParams.statusIds = [9, 10, 11, 6]
        } else {
            vendorPaymentParams.statusIds = [searchParams.statusId]
        }

        if (vendorPaymentParams.searchBy !== "all") {
            vendorPaymentParams[vendorPaymentParams.searchBy] = vendorPaymentParams.searchText.trim()
        }
        dispatch(fetchVendorPaymentsCheque(vendorPaymentParams))
    }

    const handleUpdateVendorPayments = (vendorPaymentIds, updateObj, chequeDetails) => {
        const updatedVendorPayments = vendorPaymentsData.map(eachVendorPayment => {
            if(vendorPaymentIds.includes(eachVendorPayment.vendorPaymentId)){
                return {...eachVendorPayment, ...updateObj, chequeId: chequeDetails?.chequeId, "cheques.chequeNo": chequeDetails?.chequeNo, "cheques.chequeBookId": chequeDetails?.chequeBookId}
            }
            return eachVendorPayment
        })
        dispatch(updateVendorPaymentChequeData(updatedVendorPayments))
    }

    const handleApprovePayments = () => {
        const isAllPaymentApproved = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 9)
        const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)

        if(!isAllPaymentApproved){
            return dispatch(raiseToast({severity:'error', detail: "Please select only approved vendor payments", life: 3000}))
        }

        if (relatedVendorPaymentIds?.length > 0){
            let relatedSellerBranchIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.branchId) 
            relatedSellerBranchIds = [...new Set(relatedSellerBranchIds)]

            if(relatedSellerBranchIds.length != 1){
                return dispatch(raiseToast({severity:'error', detail: "Please select vendor payments of same seller", life: 3000}))
            }
            setIsChequeModalVisible(true)
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Select the Payments", life: 3000}))
        }
    }

    const handlePaymentDoneClick = async(chequeDetails) => {
        setIsLoading(true)

        const isAllPaymentApproved = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 9)
        const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)

        if (isAllPaymentApproved){
            const updateObj = {
                vendorPaymentIds: relatedVendorPaymentIds,
                statusId: 10,
                processedBy: usersData?.userId,
                processedAt: new Date(),
                chequeDate: chequeDetails?.chequeDate,
                chequeNo: chequeDetails?.chequeNo,
                chequeBookId: chequeDetails?.chequeBookId,
                processedRemarks: chequeDetails?.remarks
            }
            if(window.confirm("Are you sure you want to approve selected vendor payments")){
                const response = await updateVendorPaymentsStatusAndCheque(updateObj)
                if (response.failure){
                    dispatch(raiseToast({severity:'error', summary: 'Payments', detail: response?.data?.error, life: 3000}))
                }else {
                    const reduxUpdateObj = {
                        statusId: 10,
                        chequeDate: chequeDetails?.chequeDate,
                        chequeNo: chequeDetails?.chequeNo,
                        chequeBookId: chequeDetails?.chequeBookId,
                        processedBy: usersData?.userId,
                        processedAt: new Date().toISOString().split('.')[0] + '.000Z'
                    }
                    if(chequeDetails?.remarks){
                        reduxUpdateObj.processedRemarks = chequeDetails?.remarks
                    }
                    handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj, response?.data?.newCheque)
                    setSelectedVendorPayments([])
                    dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Done Successfully", life: 3000}))
                }
                setIsChequeModalVisible(false)
            }else{

            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Approved.", life: 3000}))
        }
        setIsLoading(false)
    }

    const handlePaymentCancelClick = async () => {
        const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
        const isAllPaymentDone = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 10)

        if (isAllPaymentDone){
            if (relatedVendorPaymentIds?.length > 0){
                setIsCancelVisible(true)
            }else{
                dispatch(raiseToast({severity:'warn',detail: "Select the Payments", life: 3000}))
            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Payment Done", life: 3000}))
        }
    }

    const handleCancelClick = async () => {
        const isAllPaymentDone = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 10)
        
        if (isAllPaymentDone){
            setIsLoading(true)

            const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
            const updateObj = {
                vendorPaymentIds: relatedVendorPaymentIds,
                statusId: 6,
                processedBy: usersData?.userId,
                processedAt: new Date(),
                cancelReason: cancelReason
            }
            if(window.confirm("Are you sure you want to cancel selected vendor payments")){
                const response = await cancelVendorPaymentsStatus(updateObj)
                if (response.failure){
                    dispatch(raiseToast({severity:'error', summary: 'Cancel Payments', detail: response?.data?.error, life: 3000}))
                }else {
                    setCancelReason("")
                    const reduxUpdateObj = {
                        statusId: 6,
                        processedBy: usersData?.userId,
                        processedAt: new Date().toISOString().split('.')[0] + '.000Z',
                        cancelReason: cancelReason
                    }
                    handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                    setSelectedVendorPayments([])
                    setIsCancelVisible(false)
                    dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Cancelled Successfully", life: 3000}))
                }
            } 
            setIsLoading(false)
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Payment Done", life: 3000}))
        }
        setIsLoading(false)
    } 

    const handlePaymentRejectClick = async () => {
        const isAllPaymentApproved = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 9)
        
        if (isAllPaymentApproved){
            setIsLoading(true)
            const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
            if (relatedVendorPaymentIds?.length > 0){
                const updateObj = {
                    vendorPaymentIds : relatedVendorPaymentIds,
                    statusId : 11,
                    processedBy : usersData?.userId,
                    processedAt : new Date()
                }
                if(window.confirm("Are you sure you want to reject selected vendor payments")){
                    const response = await updateVendorPaymentsStatus(updateObj)
                    if (response.failure){
                        dispatch(raiseToast({severity:'error', summary: "Reject Payments", detail: response?.data?.error, life: 3000}))
                    }else {
                        const reduxUpdateObj = {
                            statusId: 11,
                            processedBy: usersData?.userId,
                            processedAt: new Date().toISOString().split('.')[0] + '.000Z'
                        }
                        handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                        setSelectedVendorPayments([])
                        dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Rejected Successfully", life: 3000}))
                    }
                }
            }else{
                dispatch(raiseToast({severity:'warn', detail: "Select the Payments", life: 3000}))
            }
            setIsLoading(false)
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Approved.", life: 3000}))
        }
        setIsLoading(false)
    }

    const handleCheckboxClick = (row) => {
        const relatedVendorPayment = selectedVendorPayments?.find(eachVendorPayment => eachVendorPayment?.vendorPaymentId === row?.vendorPaymentId)
        if (relatedVendorPayment){
            const relatedVendorPayments = selectedVendorPayments?.filter(eachVendorPayment => eachVendorPayment?.vendorPaymentId !== relatedVendorPayment?.vendorPaymentId)
            setSelectedVendorPayments(relatedVendorPayments)
        }else {
            const relatedVendorPayments = [...selectedVendorPayments, row]
            setSelectedVendorPayments(relatedVendorPayments)
        }
    }

    const handleSelectClick = (e) => {
        const relatedVendorPayments = vendorPaymentsData?.map(eachVendorPayment => eachVendorPayment)
        let updatedVendorPayments = [...selectedVendorPayments]

        if (e.checked){
            relatedVendorPayments.map(eachVendorPayment => {
                const relatedSelectedVendorPaymentExists = selectedVendorPayments.some(obj => obj.vendorPaymentId === eachVendorPayment.vendorPaymentId)
                if(!relatedSelectedVendorPaymentExists){
                    updatedVendorPayments = [...updatedVendorPayments, eachVendorPayment]
                }
            })
            setSelectedVendorPayments(updatedVendorPayments)
        }else{
            relatedVendorPayments.map(eachVendorPayment => {
                const relatedSelectedVendorPaymentExists = selectedVendorPayments.some(obj => obj.vendorPaymentId === eachVendorPayment.vendorPaymentId)
                if(relatedSelectedVendorPaymentExists){
                    updatedVendorPayments = updatedVendorPayments.filter(obj => obj.vendorPaymentId !== eachVendorPayment.vendorPaymentId)
                }
            })
            setSelectedVendorPayments(updatedVendorPayments)
        }
    }
    
    const actionButtons = [
        {
            label: "RESET",
            command: (event) => resetSelectedVendorPayments(),
        },
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
        ...(isSearchVisible ? [
            {
                icon: isSearchPinned ? "pi pi-lock" : "pi pi-lock-open",
                command: () => dispatch(setIsSearchPinned(!isSearchPinned)),
                // className: isSearchPinned ? "active-group-button" : ""
            }
        ] : [])
    ]

    return (
        <div>
            <div
                onMouseEnter={() => {
                    if (!isSearchPinned) {
                        setIsHoveringSearchZone(true)
                        setHasEverHoveredRightEdge(true)
                        dispatch(setIsSearchVisible(true))
                    }
                }}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '8px',
                    height: '100vh',
                    zIndex: 999
                }}
            />
            <div className="vp-cheque-layout flex flex-column">
                <div className="flex flex-column md:flex-row md:justify-content-between">
                    <h4 className="mx-2 my-1 md:m-2">VENDOR PAYMENT CHEQUE</h4>
                    <div className="flex flex-column md:flex-row justify-content-between mb-2">
                        <div className="md:mr-2 md:mb-0 mb-2 ml-2">
                            <p className="mb-0 selected-amount" style={{fontSize: "15px"}}>Selected Amount: {selectedVendorPaymentsAmount}</p>
                        </div>
                        <div className="mr-2 flex justify-content-end">
                            {/* <Button className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="RESET" onClick={resetSelectedVendorPayments} /> */}
                            <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                            {/* <Button className="h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                            <Button icon="pi pi-filter" className={`h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                            <ButtonGroup buttons={actionButtons} />
                        </div>
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div className="vp-cheque-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                        <div className='p-card mb-0' >
                            <div className="flex-grow-1" >
                                <Table
                                    lazy
                                    page={paginationParams.pageNo}
                                    onPageChange={(e)=> handlePageChange(e)} 
                                    totalRecords={paginationParams.totalRecords}
                                    tableColumns={tableColumns}
                                    rows={paginationParams.recordsPerPage}
                                    data={vendorPaymentsData}
                                    scrollable={"true"}
                                    scrollHeight="550px"
                                    paginator
                                    loading={isTableLoading}
                                />
                            </div>
                        </div>
                    </div>

                    {(((isSearchPinned || (isHoveringSearchZone && isSearchVisible)) && hasEverHoveredRightEdge) || (isSearchVisible && !isMobileDevice)) && (
                    <div
                        style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end"
                        onMouseLeave={(e) => {
                            const bounds = e.currentTarget.getBoundingClientRect()
                            const leftExit = e.clientX < bounds.left
                            const topExit = e.clientY < bounds.top
                            const bottomExit = e.clientY > bounds.bottom

                            if (!isSearchPinned && (leftExit || topExit || bottomExit)) {
                                setIsHoveringSearchZone(false)
                                setHasEverHoveredRightEdge(false)
                            }
                        }}

                        onMouseEnter={() => {
                            if (!isSearchPinned) {
                                setIsHoveringSearchZone(true)
                            }
                        }}
                    >
                        <Search selectedVendorPayments={selectedVendorPayments} />
                    </div>
                )}

                    {/* {
                        isSearchVisible && !isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Search selectedVendorPayments={selectedVendorPayments} />
                        </div>
                    } */}

                    {
                        isSearchVisible && isMobileDevice &&
                            <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                                <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                                    <Search selectedVendorPayments={selectedVendorPayments} />
                                </Sidebar>
                            </div>
                    }

                    <Dialog header="Cancel Vendor Payment" visible={isCancelVisible} style={{ width: '35vw', height: '30vh' }} onHide={() => setIsCancelVisible(false)}>
                        <div>
                            <div className="grid">
                                <div className="flex flex-column col-12 mb-0">
                                    <TextAreaField name="reason" labelText="Cancel Reason" value={cancelReason} onChange={e => setCancelReason(e.target.value)}/>
                                </div>
                            </div>
                            <div className="flex justify-content-end mt-4">
                                <Button  className="h-2rem  p-2" label="Cancel" onClick={handleCancelClick}/>   
                            </div>
                        </div>
                    </Dialog>

                    <ChequeModal header = "Assign Cheque to Vendor Payment" visible={isChequeModalVisible} onHide={()=> setIsChequeModalVisible(false)} handlePaymentDoneClick={handlePaymentDoneClick} setIsChequeModalVisible={setIsChequeModalVisible}/>

                    <Dialog header="Purchase Invoice" visible={isPIVisible} style={{ width: '75vw', minHeight: '30vh' }} onHide={() => {setIsPIVisible(false); setSellerPIPunch([])}}>
                        <div className="ml-2 mr-2 mt-0 pt-0">
                            <div>
                                <div className="flex justify-content-between">
                                    <div className="flex flex-wrap py-2 w-full">
                                        <div className="flex justify-content-between flex-grow-1 font-bold text-sm header-style" style={{ borderBottom: '1px solid rgb(217 227 222)' }}>
                                            <div className="mt-1" style={{ width: '10%' }}>PI Punch</div>
                                            <div className="mt-1" style={{ width: '20%' }}>PI Number</div>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Date</div>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Uploaded Date</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Booking Status</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Booked Date</div>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Document</div>
                                        </div>
                                        {
                                            sellerPIPunch?.map(eachSellerPIPunch => {
                                                return (
                                                    <div className="flex justify-content-between flex-grow-1 w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)' ,fontSize: "13px"}}>
                                                        <div className="py-1 align-self-center" style={{ width: '10%' }}>
                                                            {eachSellerPIPunch?.PIDocNo}
                                                        </div>
                                                        <div className="py-1 align-self-center" style={{ width: '20%' }}>{eachSellerPIPunch?.sellerPINumber}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.sellerPIDate ? getDateString(eachSellerPIPunch.sellerPIDate) : ""}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.sellerPIUploadedDate ? getDateString(eachSellerPIPunch.sellerPIUploadedDate) : ""}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.bookedStatus ? "Booked" : "Not Booked"}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.bookedAt ? getDateString(eachSellerPIPunch.bookedAt) : ""}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>
                                                            { eachSellerPIPunch?.sellerPIDocProof ? <a href={ eachSellerPIPunch.sellerPIDocProof} target="_blank" >View</a> : "" }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog header="Bank Details" visible={isBankDetailsVisible} style={{ width: '60vw', height: '30vh' }} onHide={() => {setIsBankDetailsVisible(false); setDisplayedBankDetails([])}}>
                        <div className="ml-2 mr-2 mt-0 pt-0">
                            <div>
                                <div className="flex justify-content-between">
                                    <div className="flex flex-wrap py-2 w-full">
                                        <div className="flex justify-content-between flex-grow-1 font-bold header-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize:"14px" }}>
                                            <div className="mt-1" style={{ width: '20%' }}>Bank Name</div>
                                            <div className="mt-1" style={{ width: '20%' }}>Account Holder Name</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Account No</div>
                                            <div className="mt-1" style={{ width: '12%' }}>IFSC Code</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Document</div>
                                        </div>
                                        {
                                            displayedBankDetails?.map(eachBankDetails => {
                                                return (
                                                    <div className="flex justify-content-between flex-grow-1 w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                                        <div className="py-1 align-self-center" style={{ width: '20%' }}>{eachBankDetails?.bankName}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '20%' }}>{eachBankDetails?.holderName}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachBankDetails?.accNo}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachBankDetails?.ifscCode}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>
                                                            { eachBankDetails?.documentProof ? <a href={ eachBankDetails.documentProof} target="_blank" >View</a> : "" }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <Loading visible={isLoading}/>
                </div>
            </div>
        </div>
    )
}

export default VendorPaymentCheque;
